export { default as Default } from './default'


// WEBPACK FOOTER //
// ./src/generator/index.ts